import ElementHandler from "./ElementHandler";
export default class EventHandler extends ElementHandler {
    targetContent;
    constructor(targetContent) {
        super();
        this.targetContent = targetContent;
    }
    attachEventOfResultElement(登録する要素のクラス, pointOutAnalysis) {
        const targetResultElements = document.getElementsByClassName(`${登録する要素のクラス}`);
        const resultParentElement = document.getElementById('js-result-content');
        for (let i = 0; i < targetResultElements.length; i++) {
            targetResultElements[i].addEventListener('click', (event) => {
                const target = targetResultElements[i];
                const ruleIndex = target.dataset.rule_idx;
                const ruleType = target.dataset.rule_type;
                const searchIndex = this.findPointOutIndexByOrder(ruleIndex, ruleType, pointOutAnalysis);
                // ハイライト対象のspan要素を取得
                const targetSpan = this.findHighlightSpanElement(searchIndex, ruleIndex);
                //結果・入力画面にハイライトを表示
                this.setElementAsActiveAndDeactivateOthers(target, resultParentElement, 'is-active');
                this.setElementAsActiveAndDeactivateOthers(targetSpan, this.targetContent, ['p-topInput__yellow', 'p-topInput__orange']);
                // 半角スペースなど、文字がない場合は、追加のクラスが必要
                this.addClassIfTextIsEmpty(targetSpan);
                //関連するスパンのハイライト
                this.highlightRelatedSpans(ruleType, [ruleIndex]);
                //入力エリアのスクロール
                this.scrollToElement(targetSpan);
                event.stopPropagation();
            });
        }
    }
    attachEventOfPointOutSpan(pointOutSpanContentsClass, pointOutAnalysis) {
        const pointOutSpanContents = document.getElementsByClassName(`${pointOutSpanContentsClass}`);
        for (let i = 0; i < pointOutSpanContents.length; i++) {
            pointOutSpanContents[i].addEventListener('click', (event) => {
                const targetSpan = event.target;
                const currentType = targetSpan.dataset.info_type;
                const orders = targetSpan.dataset.order?.split(' ');
                const { targetIndex, pointOutAnalysis: nextPointOutAnalysis } = this.updatePointOutAnalysis(currentType, orders, pointOutAnalysis, targetSpan);
                pointOutAnalysis = nextPointOutAnalysis;
                const parentTabUl = this.setActiveTab(currentType);
                if (parentTabUl === undefined)
                    return;
                const target = parentTabUl.querySelector(`li[data-rule_idx="${targetIndex}"]`);
                if (target === null)
                    return;
                this.setElementAsActiveAndDeactivateOthers(target, parentTabUl, 'is-active');
                this.scrollToElement(target);
                this.removeClassFromDescendants(this.targetContent, 'p-topInput__yellow');
                this.setElementAsActiveAndDeactivateOthers(targetSpan, this.targetContent, 'p-topInput__orange');
                // 半角スペースなど、文字がない場合は、追加のクラスが必要
                this.addClassIfTextIsEmpty(targetSpan);
                this.highlightRelatedSpans(currentType, orders);
                event.stopPropagation();
            });
        }
    }
    /**
     *
     * @param ignoreBtnClass
     * @param addIgnoreRuleId
     * @param hideLintResult
     * @param removePointOutSpan
     * @param decrementLintErrorPointCounter
     *
     * エラーを無視するボタンを押したときの処理
     * 校正結果の非表示、該当ハイライトの削除、エラーポイントのカウントダウン
     * また、無視するルールIDを追加し、次回の校正時には無視されるようにする
     */
    attachErrorClickIgnoreBtn(ignoreBtnClass, addIgnoreRuleId, hideLintResult, removePointOutSpan, decrementLintErrorPointCounter, updateFixCounter) {
        const ignore = document.getElementsByClassName(ignoreBtnClass);
        for (let i = 0; i < ignore.length; i++) {
            ignore[i].addEventListener('click', (event) => {
                const liElement = ignore[i]?.parentElement?.parentElement?.parentElement?.parentElement;
                const uniqueId = liElement?.dataset.unique_id;
                addIgnoreRuleId(uniqueId);
                hideLintResult(uniqueId);
                removePointOutSpan(uniqueId);
                decrementLintErrorPointCounter();
                // liElementに input class='js-fix-flg' がある場合、チェックを外す
                document.querySelectorAll(`.js-fix-flg[data-unique_id="${uniqueId}"]`).forEach((checkbox) => {
                    if (checkbox.checked) {
                        checkbox.checked = false;
                    }
                });
                const fixCheckBoxes = document.getElementsByClassName('js-fix-flg');
                let count = 0;
                //無視するボタンを押したときに、li要素が非表示になるため、非表示のli要素はカウントしない
                Array.from(fixCheckBoxes).forEach((element, index) => {
                    const liElement = element.parentElement?.parentElement?.parentElement?.parentElement;
                    if (liElement === null || liElement?.style.display == 'none')
                        return;
                    if (element.checked)
                        count++;
                });
                updateFixCounter(count);
                event.stopPropagation();
            });
        }
    }
    /**
     *
     * @param fixCheckBoxClass
     * @param updateFixCounter
     * lintの自動修正チェックボックスのイベントを設定
     * 同じruleのチェックボックスを同じ状態にする
     * 自動修正の数をカウントする
     */
    attachEventOfFixCheckBox(fixCheckBoxClass, updateFixCounter) {
        const fixCheckBoxes = document.getElementsByClassName(fixCheckBoxClass);
        for (let i = 0; i < fixCheckBoxes.length; i++) {
            fixCheckBoxes[i].addEventListener('click', (event) => {
                const target = fixCheckBoxes[i];
                //同じvalueのチェックボックスを同じ状態にする
                const value = target.dataset.unique_id;
                document.querySelectorAll(`.js-fix-flg[data-unique_id="${value}"]`).forEach((element, index) => {
                    element.checked = target.checked;
                });
                let count = 0;
                Array.from(fixCheckBoxes).forEach((element, index) => {
                    const liElement = element.parentElement?.parentElement?.parentElement?.parentElement;
                    if (liElement === null || liElement?.style.display == 'none')
                        return;
                    if (element.checked)
                        count++;
                });
                updateFixCounter(count);
                event.stopPropagation();
            });
        }
    }
    updatePointOutAnalysis(currentType, orders, pointOutAnalysis, targetSpan) {
        const index = targetSpan.dataset.index;
        let targetIndex = Number(index);
        if (pointOutAnalysis.hasOwnProperty(index) && pointOutAnalysis[index].hasOwnProperty(currentType)) {
            targetIndex = pointOutAnalysis[index][currentType][0];
            // let nextOrders = orders;
            // const types = Object.keys(pointOutAnalysis[index]);
            // const currentTypeIndex = types.findIndex(t => t == currentType);
            // const nextTypeIndex = (currentTypeIndex + 1) % types.length;
            // const nextType = types[nextTypeIndex];
            // const addNextOrder = nextOrders.shift();
            // if(addNextOrder != undefined){
            //     nextOrders.push(addNextOrder);
            //     targetSpan.dataset.info_type = nextType;
            //     targetSpan.dataset.order = nextOrders.join(' ');
            //     targetIndex = pointOutAnalysis[index][currentType][0];
            //     const addNextType = pointOutAnalysis[index][currentType].shift();
            //     if(addNextType != undefined){
            //         pointOutAnalysis[index][nextType].push(addNextType);
            //     }
            // }
        }
        return {
            targetIndex: targetIndex,
            pointOutAnalysis: pointOutAnalysis,
        };
    }
    setActiveTab(currentType) {
        const tabId = `js-${currentType}-tab`;
        const contentId = `js-${currentType}-content`;
        const tab = document.getElementById(tabId);
        const content = document.getElementById(contentId);
        const ul = content.querySelector('ul');
        if (ul === null)
            return;
        this.removeClassFromElements(document.querySelectorAll(".js-tabKick"), 'is-active');
        tab.classList.add("is-active");
        this.hideElements(Array.from(document.querySelectorAll(".js-tabCont")));
        content.style.display = "block";
        return ul;
    }
    findPointOutIndexByOrder(resultOrder, pointOutType, pointOutAnalysis) {
        let pointOutIndex = 0;
        Object.entries(pointOutAnalysis).forEach(([key, value]) => {
            if (value.hasOwnProperty(pointOutType)) {
                const indexes = value[pointOutType];
                if (indexes.includes(parseInt(resultOrder))) {
                    pointOutIndex = parseInt(key);
                    return;
                }
            }
        });
        return pointOutIndex;
    }
    findHighlightSpanElement(searchIndex, ruleIndex) {
        return (this.targetContent.querySelector(`span[data-index="${searchIndex}"]`)
            ?? this.targetContent.querySelector(`span[data-rule_idx="${ruleIndex}"]`));
    }
    highlightRelatedSpans(pointOutType, orders) {
        const allSpans = this.targetContent.querySelectorAll(`span[data-order][data-info_type="${pointOutType}"]`);
        const targetSpans = Array.from(allSpans).filter(span => span?.dataset?.order?.split(' ').includes(orders[0]));
        this.addClassToElements(targetSpans, 'p-topInput__yellow');
    }
    addClassIfTextIsEmpty(targetSpan) {
        if (!targetSpan || targetSpan.innerText.trim() != '')
            return;
        //半角スペースや全角スペースの場合、クリックしハイライトを表示すると、スペースが潰れてしまうため、
        //スペースの場合は、追加のクラスを付与する
        if (targetSpan.textContent === '　') {
            this.setElementAsActiveAndDeactivateOthers(targetSpan, this.targetContent, 'p-top__full-space');
        }
        else if (targetSpan.textContent === ' ') {
            this.setElementAsActiveAndDeactivateOthers(targetSpan, this.targetContent, 'p-top__half-space');
        }
    }
}
